import { useState } from 'react';
import { OptionProps } from '@match/react-component-library';

function useDropDownSelection(intitialValue: string = '') {
  const [value, setValue] = useState<string>(intitialValue);
  const handleSetValue = (selection?: OptionProps<{}>) => {
    if (selection) {
      setValue(selection.value.toString());
    }
  };
  return { value, handleSetValue };
}

export default useDropDownSelection;
